import { useLiquity } from "src/hooks/LiquityContext";
import { getContractAddressByCollateralKey } from "@liquity/lib-ethers";
import { StabilityPoolListRow } from "../components/Stability/PSY/StabilityPoolListRow";
import { CollateralBaseState, CollateralDerivedState, LiquityStoreState } from "@liquity/lib-base"
import { merge } from "lodash";
import { useLiquitySelector } from "@liquity/lib-react"
import { CollateralLexicons } from "src/lexicon"
import { Fragment } from "react"

type ResultSelector = Pick<CollateralBaseState & CollateralDerivedState, "stabilityDeposit" | "slsdInStabilityPool">

const select = ({ collateralStates, collateralDerivedStates }: LiquityStoreState) => {
  const collStates = merge(collateralStates, collateralDerivedStates)

  const selected = Object.entries(collStates).reduce<{ [collateralKey: string]: ResultSelector }>((acc, [key, value]) => {
    const { stabilityDeposit, slsdInStabilityPool } = value
    acc[key] = { stabilityDeposit, slsdInStabilityPool }
    return acc
  }, {})
  return { ...selected }
};

export const StabilityPoolList: React.FC = () => {
  const { liquity: { connection } } = useLiquity();
  const spList = useLiquitySelector(select);


  const spWithAddressList = Object.entries(spList).map(([key, result]) => {
    const { spAddress } = getContractAddressByCollateralKey(connection, key)
    const lexicon = CollateralLexicons.find(sp => sp.key === key)
    return { key, lexicon, ...result, spAddress }
  })

  return(
    <>
      <div className="flex flex-col md:flex-wrap w-full h-full md:h-[900px] md:mt-6">
        <div className="text-style-title">Stability Pool</div>
        <div className="flex flex-col gap-1 mt-8">
          {spWithAddressList.map(({ lexicon, stabilityDeposit, slsdInStabilityPool, spAddress }, index) => (
            <Fragment key={index}>
              {!!spAddress && !!lexicon && (
                <StabilityPoolListRow
                  lexicon={lexicon}
                  stabilityDeposit={stabilityDeposit}
                  slsdInStabilityPool={slsdInStabilityPool}
                  spAddress={spAddress}
                />
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </>
  )
};
